import { Routes } from '@angular/router';
import { CompanionChatPageComponent } from './components/companion-chat/companion-chat-page.component';

export const NEW_CONVERSATION_ID = 'new';

export const companionChatRoutes: Routes = [
  {
    path: '',
    redirectTo: NEW_CONVERSATION_ID,
    pathMatch: 'full',
  },
  {
    path: ':id',
    component: CompanionChatPageComponent,
  },
];
